// Pure helpers for the question card (a .ts file, so QuestionCard.tsx keeps
// to components for react-refresh).

import type { QuestionResponse } from '../../services/roadmapReports';
import styles from './RoadmapV2.module.css';

/** The card's class for its response state: open, answered (green) or dismissed (struck). */
export function cardClass(response: QuestionResponse | null | undefined): string {
  if (!response) return styles.askCard;
  return `${styles.askCard} ${response.kind === 'answered' ? styles.askCardAnswered : styles.askCardDismissed}`;
}
